<template>
  <div class="wedding-abc">
    <v-card
      v-for="(contact, i) in contacts"
      :key="i"
      class="card mx-auto"
      lighten
      raised
    >
      <v-img
        :src="contact.src"
        class="white--text align-end"
        gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
        height="300px"
      >
        <v-card-title>{{ contact.name }}</v-card-title>
      </v-img>

      <v-card-subtitle class="pb-0">{{ contact.function }}</v-card-subtitle>

      <v-card-text class="text--primary" style="letter-spacing: 2px">
        <div>
          <a :href="'mailto:' + contact.mail"
            ><v-icon color="primary">mail</v-icon></a
          >
          <a :href="'mailto:' + contact.mail">{{ contact.mail }}</a>
        </div>
        <div>
          <a :href="'tel:' + contact.phone"
            ><v-icon color="primary">phone</v-icon></a
          >
          <a :href="'tel:' + contact.phone">{{ contact.phone }}</a>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<style scoped>
.wedding-abc {
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: baseline;
  align-content: center;
  padding: 20px;
}
a + a {
  margin-left: 10px;
}
.card {
  max-width: 350px;
  width: 100%;
  margin-bottom: 20px;
}
</style>
<script>
export default {
  name: "contact",
  data: () => ({
    contacts: {
      lina: {
        name: "Melina Grupp",
        mail: "melina@meloni-hochzeit.de",
        phone: "+49 1590 02498296",
        src: "images/nobody.jpg"
      },
      koni: {
        name: "Konstantin Grupp",
        mail: "koni@meloni-hochzeit.de",
        phone: "+49 1590 2166798",
        src: "images/nobody.jpg"
      },
      frank: {
        name: "Frank Sommer",
        mail: "frank@meloni-hochzeit.de",
        function: "Trauzeuge",
        phone: "+49 1522 7539233",
        src: "images/nobody.jpg"
      },
      marlene: {
        name: "Marlene Breuer",
        mail: "marlene@meloni-hochzeit.de",
        function: "Trauzeugin",
        phone: "+49 162 4721619",
        src: "images/nobody.jpg"
      }
    }
  })
};
</script>
